document.addEventListener('switch_box:activated', (e) => {
  let header = document.querySelector('#plan-page-header')
  if (!header) return

  document
    .querySelectorAll('.plan-preview')
    .forEach((item) => item.classList.add('hidden'))

  document
    .querySelectorAll('.plan-' + e.detail.box.dataset.plan)
    .forEach((item) => item.classList.remove('hidden'))

  let simpleroOfferPlans = header.dataset.simpleroOfferPlans

  if (!simpleroOfferPlans) return

  simpleroOfferPlans = simpleroOfferPlans.split(',')

  if (simpleroOfferPlans.indexOf(e.detail.box.dataset.plan) > -1) {
    header.classList.remove('plan-excluded')
  } else {
    header.classList.add('plan-excluded')
  }
})

document.addEventListener('switch:activated', (e) => {
  if (e.detail.name !== 'account[billing_cycle]') return

  document
    .querySelectorAll('[data-billing-circle]')
    .forEach((item) => item.classList.add('hidden'))

  document
    .querySelectorAll(`[data-billing-circle="${e.detail.value}"]`)
    .forEach(function (item) {
      item.classList.remove('hidden')
    })
})
